/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type IntegrationsOverviewQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type IntegrationsOverviewQuery = { integrations: { __typename: 'IntegrationConnection', edges: Array<{ __typename: 'IntegrationEdge', node: { __typename: 'Integration', id: string, integrationId: Types.IntegrationId, name: string, isForeignAccountIdRequired: boolean } }> } | { __typename: 'MissingCapabilities' }, organisationIntegrations: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'OrganisationIntegrationConnection', edges: Array<{ __typename: 'OrganisationIntegrationEdge', node: { __typename: 'OrganisationIntegration', id: string, settings: any, integration: { __typename: 'Integration', id: string, integrationId: Types.IntegrationId, name: string }, health?: { __typename: 'IntegrationHealth', health: string, details?: any | null, updatedAt?: string | null } | null } }> } };

export type IntegrationsOverview_RemoveMutationVariables = Types.Exact<{
  input: Types.RemoveOrganisationIntegrationInput;
}>;


export type IntegrationsOverview_RemoveMutation = { removeOrganisationIntegration: { __typename: 'RemoveOrganisationIntegrationResult', ok?: boolean | null } };


export const IntegrationsOverviewDocument = gql`
    query IntegrationsOverview {
  integrations(limit: 1000) {
    ... on IntegrationConnection {
      edges {
        node {
          id
          integrationId
          name
          isForeignAccountIdRequired
        }
      }
    }
  }
  organisationIntegrations(limit: 1000) {
    ... on OrganisationIntegrationConnection {
      edges {
        node {
          id
          integration {
            id
            integrationId
            name
          }
          settings
          health {
            health
            details
            updatedAt
          }
        }
      }
    }
  }
}
    `;

/**
 * __useIntegrationsOverviewQuery__
 *
 * To run a query within a React component, call `useIntegrationsOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationsOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationsOverviewQuery({
 *   variables: {
 *   },
 * });
 */
export function useIntegrationsOverviewQuery(baseOptions?: Apollo.QueryHookOptions<IntegrationsOverviewQuery, IntegrationsOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntegrationsOverviewQuery, IntegrationsOverviewQueryVariables>(IntegrationsOverviewDocument, options);
      }
export function useIntegrationsOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntegrationsOverviewQuery, IntegrationsOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntegrationsOverviewQuery, IntegrationsOverviewQueryVariables>(IntegrationsOverviewDocument, options);
        }
export function useIntegrationsOverviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IntegrationsOverviewQuery, IntegrationsOverviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IntegrationsOverviewQuery, IntegrationsOverviewQueryVariables>(IntegrationsOverviewDocument, options);
        }
export type IntegrationsOverviewQueryHookResult = ReturnType<typeof useIntegrationsOverviewQuery>;
export type IntegrationsOverviewLazyQueryHookResult = ReturnType<typeof useIntegrationsOverviewLazyQuery>;
export type IntegrationsOverviewSuspenseQueryHookResult = ReturnType<typeof useIntegrationsOverviewSuspenseQuery>;
export type IntegrationsOverviewQueryResult = Apollo.QueryResult<IntegrationsOverviewQuery, IntegrationsOverviewQueryVariables>;
export const IntegrationsOverview_RemoveDocument = gql`
    mutation IntegrationsOverview_Remove($input: RemoveOrganisationIntegrationInput!) {
  removeOrganisationIntegration(input: $input) {
    ok
  }
}
    `;
export type IntegrationsOverview_RemoveMutationFn = Apollo.MutationFunction<IntegrationsOverview_RemoveMutation, IntegrationsOverview_RemoveMutationVariables>;

/**
 * __useIntegrationsOverview_RemoveMutation__
 *
 * To run a mutation, you first call `useIntegrationsOverview_RemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIntegrationsOverview_RemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [integrationsOverviewRemoveMutation, { data, loading, error }] = useIntegrationsOverview_RemoveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIntegrationsOverview_RemoveMutation(baseOptions?: Apollo.MutationHookOptions<IntegrationsOverview_RemoveMutation, IntegrationsOverview_RemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IntegrationsOverview_RemoveMutation, IntegrationsOverview_RemoveMutationVariables>(IntegrationsOverview_RemoveDocument, options);
      }
export type IntegrationsOverview_RemoveMutationHookResult = ReturnType<typeof useIntegrationsOverview_RemoveMutation>;
export type IntegrationsOverview_RemoveMutationResult = Apollo.MutationResult<IntegrationsOverview_RemoveMutation>;
export type IntegrationsOverview_RemoveMutationOptions = Apollo.BaseMutationOptions<IntegrationsOverview_RemoveMutation, IntegrationsOverview_RemoveMutationVariables>;